import "./App.css";
import React, { Component, Fragment } from "react";
import LoadingPopup from "./components/helpers/loading_component.js";
import Calendar from "./components/functionalites/calendar.js";
import ConfRoomRes from "./components/functionalites/conf_room_res.js";
import AddDate from "./components/functionalites/add_date.js";
import AddTask from "./components/functionalites/add_task.js";
import DatePopUp from "./components/functionalites/date_popup.js";
import TaskPopUp from "./components/functionalites/task_popup.js";
import SearchPopUp from "./components/functionalites/search_popup.js";
import Payments from "./components/functionalites/payments.js";
import Clients from "./components/functionalites/clients.js";
import ReportPopUp from "./components/functionalites/report_popup.js";
import Holiday from "./components/functionalites/holiday.js";
import HolidayUser from "./components/functionalites/holiday_user.js";
import AcceptHearings from "./components/functionalites/accept_hearings.js";
import NewPopUp from "./components/functionalites/new_popup.js";
import Login from "./components/functionalites/login.js";
import Header from "./components/helpers/header.js";
import Footer from "./components/helpers/footer.js";
import Functionalites from "./components/helpers/functionalites.js";
import AddPayment from "./components/functionalites/add_payment.js";
import AddClientContactPopUp from "./components/functionalites/addClientContact_popup.js";
import AddClient from "./components/functionalites/addClient_popup.js";
import AdminPanel from "./components/functionalites/adminPanel.js";
import AdminPanelUserAccess from "./components/functionalites/adminPanelUserAccess.js";
import AcceptClients from "./components/functionalites/acceptClients.js";
import AcceptLeads from "./components/functionalites/acceptLeads.js";
import SellSystem from "./components/functionalites/sellSystem.js";
import AddQuestionnaireClient from "./components/functionalites/addQuestionnaireClient.js";
import AddClientSellDocuments from "./components/functionalites/addClientSellDocuments.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "./data";
import SellTaskPopUp from "./components/functionalites/sellTask_popup.js";
import Materials from "./components/functionalites/materials";
import MaterialsCons from "./components/functionalites/materialsCons";
import AddClientSellDocumentsSKD from "./components/functionalites/addClientSellDocumentsSKD";
import PostBook from "./components/functionalites/postBook";
import ChecklistReport from "./components/functionalites/checklistReport";
import UndevDeliveries from "./components/functionalites/udevDeliveries";

const MySwal = withReactContent(Swal2);

class App extends Component {
  state = {
    loged: 0,
    user: [],
    showDatePopUp: false,
    showTaskPopUp: false,
    showSellTaskPopUp: false,
    showSearchPopUp: false,
    showReportPopUp: false,
    showHoliday: false,
    showMultiAcceptHearings: false,
    showPayments: false,
    showAddPayments: false,
    showAddClientContact: false,
    showAcceptClients: false,
    showAcceptLeads: false,
    showAddClient: false,
    showClients: false,
    showAdminPanel: false,
    showAdminPanelUA: false,
    showSellSystem: false,
    showSellSystemCalendar: false,
    showConfRoomResS: false,
    showMaterials: false,
    showMaterialsCons: false,
    showPostBook: false,
    showChceklistReport: false,
    showUndevList: false,
    popUpDateID: "",
    popUpTaskID: "",
    popUpSellTaskID: "",
    hearingsData: [],
    tasksData: [],
    tasksTypesData: [],
    monthData: [],
    courtsData: [],
    banksData: [],
    usersData: [],
    paymentsData: [],
    paymentsSheetData: [],
    transactionsData: [],
    transactionsSheetData: [],
    transactionsNaData: [],
    transactionsNaSheetData: [],
    paymentsArchiveData: [],
    paymentsArchiveSheetData: [],
    substitutesData: [],
    lawyersData: [],
    resultsData: [],
    hearingsSheetData: [],
    tasksSheetData: [],
    hearingsArchSheetData: [],
    tasksArchSheetData: [],
    tasksArchTeam2SheetData: [],
    docInfo: "",
    loadingData: true,
    loadedStartedData: false,
    view: "month",
    views: ["month", "week", "quarter", "year"],
    date: new Date(),
    option: "calendar",
    userCalendar: "",
    hearingsCalendar: true,
    tasksCalendar: true,
    tasksComissioned: true,
    tasksFinalized: true,
    tasksSell: false,
    checkNewPopup: false,
    tasksCourtFilter: true,
    tasksNoCourtFilter: true,
    tasksNoClientFilter: false,
    resultFilter: "",
    clientTypeFilter: "",
    caseTypeFilter: "",
    caseFormFilter: "",
    courtFilter: "",
    taskTypeFilter: "",
    hearingsTeam2SheetData: [],
    hearingsArchTeam2SheetData: [],
    hearingsTeam2Data: [],
    team: 1,
    allowedTeam: [],
    holidaysData: [],
    holidaysSheetData: [],
    holidaysBlockData: [],
    holidaysBlockSheetData: [],
    freeDaysData: [],
    freeDaysSheetData: [],
    yearHolidaysData: [],
    yearHolidaysSheetData: [],
    clientsData: [],
    clientsSheetData: [],
    clientsSygnData: [],
    clientsSygnSheetData: [],
    holidayView: "month",
    payId: null,
    tabIndex: 0,
    clientsContactData: [],
    clientsContactSheetData: [],
    clientsLogsData: [],
    clientsLogsSheetData: [],
    clientsQuestData: [],
    clientsQuestSheetData: [],
    clientId: "",
    clientQuest: false,
    clientUpload: false,
    clientSKDUpload: false,
    desksData: [],
    deskResData: [],
    filesData: [],
  };

  async fetchFiles() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getFiles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          filesData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchDesks() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getDesks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          desksData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchDesksRes() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getDesksRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          deskResData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchClientsContacts() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsContacts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsContactData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchClientsQuestionnaires() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsQuestionnaires", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsQuestData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchClientsLogs() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsLogs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsLogsData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchClients() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClients", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsData: data.filter((el) => +el.team === +this.state.team),
        });
      })
      .catch((error) => {});
  }

  async fetchClientsQuest() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsQuestionnaires", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsQuestData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchClientsSygn() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          clientsSygnData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchYearsHolidays() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getYearsHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          yearHolidaysData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchPayments() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          paymentsData: data.filter((el) => !el.archive_date),
        });
      })
      .catch((error) => {});
  }

  async fetchHolidays() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          holidaysData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchFreeDays() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          freeDaysData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchHolidaysBlocks() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidaysBlocks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          holidaysBlockData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchPaymentsArchive() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          paymentsArchiveData: data.filter((el) => el.archive_date),
        });
      })
      .catch((error) => {});
  }

  async fetchTransactions() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          transactionsData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchTransactionsNa() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsNotAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          transactionsNaData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchMonths() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMonths", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          monthData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchResults() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          resultsData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchTaskTypes() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskTypes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          tasksTypesData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchBanks() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          banksData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchCourts() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          courtsData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchSubstitutes() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSubstitutes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          substitutesData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchUsers() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          usersData: data,
        });
      })
      .catch((error) => {});
  }

  async fetchLawyers() {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          lawyersData: data,
        });
      })
      .catch((error) => {});
  }

  setUserCalendar = (e) => {
    this.setState({
      userCalendar: e.target.value,
    });
  };

  setUserCalendar = (e) => {
    this.setState({
      userCalendar: e.target.value,
    });
  };

  setHearingsCalendar = (e) => {
    this.setState((prevState) => ({
      hearingsCalendar: !prevState.hearingsCalendar,
    }));
  };

  setTasksCalendar = (e) => {
    this.setState((prevState) => ({
      tasksCalendar: !prevState.tasksCalendar,
    }));
  };

  setTasksComissioned = (e) => {
    this.setState((prevState) => ({
      tasksComissioned: !prevState.tasksComissioned,
    }));
  };

  setTasksFinalized = (e) => {
    this.setState((prevState) => ({
      tasksFinalized: !prevState.tasksFinalized,
    }));
  };

  setTasksSell = (e) => {
    this.setState((prevState) => ({
      tasksSell: !prevState.tasksSell,
    }));
  };

  getData(type) {
    //this.fetchClientsContacts();
    //this.fetchClientsLogs();
    //this.fetchClientsQuestionnaires();
    if (type === "quest") {
      //this.fetchClientsQuest();
    } else {
      //this.fetchClients();
    }
    //this.fetchClientsSygn();
    this.fetchYearsHolidays();
    //this.fetchPayments();
    //this.fetchHolidays();
    //this.fetchFreeDays();
    //this.fetchHolidaysBlocks();
    //this.fetchPaymentsArchive();
    //this.fetchTransactions();
    //this.fetchTransactionsNa();
    this.fetchMonths();
    this.fetchResults();
    this.fetchTaskTypes();
    this.fetchBanks();
    this.fetchCourts();
    this.fetchSubstitutes();
    this.fetchUsers();
    this.fetchLawyers();
    this.fetchDesks();
    //this.fetchDesksRes();
    //this.fetchFiles();
  }

  getDataRefresh() {
    this.fetchClientsContacts();
    this.fetchClientsLogs();
    this.fetchClientsQuestionnaires();
    //this.fetchClients();
    this.fetchClientsSygn();
    this.fetchYearsHolidays();
    this.fetchPayments();
    //this.fetchHolidays();
    this.fetchFreeDays();
    this.fetchHolidaysBlocks();
    //this.fetchPaymentsArchive();
    //this.fetchTransactions();
    //this.fetchTransactionsNa();
    //this.fetchHearingsTeam1();
    //this.fetchHearingsTeam2();
    //this.fetchTasksTeam1();
    //this.fetchTasksTeam2();
    this.fetchMonths();
    //this.fetchResults();
    //this.fetchTaskTypes();
    //this.fetchBanks();
    //this.fetchCourts();
    //this.fetchSubstitutes();
    //this.fetchUsers();
    //this.fetchLawyers();
    //this.fetchDesks();
    this.fetchDesksRes();
    this.fetchFiles();
  }

  getDataRefreshOnlyHearings() {
    var counter = 0;
    if (this.state.loadingData && !this.state.loadedStartedData) {
      const interval = setInterval(() => {
        if (counter === 0) {
          this.createTasksDataSet();
          this.createTasksTeam2DataSet();
          counter++;
        } else {
          counter++;
        }
        if (counter === 10 && this.state.paymentsData.length === 0) {
          counter = 0;
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }

  getSheetData(type) {
    this.checkDataFill();
    this.getData(type);
  }

  getSheetDataOnlyHearings(refresh) {
    if (this.state.loadingData) {
      this.checkDataFillOnlyHearings();
      if (refresh === 1) {
        this.getDataRefreshOnlyHearings();
      } else {
        this.getData();
      }
    }
  }

  checkDataFill() {
    const interval = setInterval(() => {
      if (true) {
        this.setState({
          loadingData: false,
          loadedStartedData: true,
        });
        return;
      }
    }, 100);
    return () => clearInterval(interval);
  }

  checkDataFillOnlyHearings() {
    const interval = setInterval(() => {
      if (this.state.tasksData.length > 0) {
        this.setState({
          loadingData: false,
          loadedStartedData: true,
        });
        return;
      }
    }, 100);
    return () => clearInterval(interval);
  }

  subtractMonths = (numOfMonths) => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - numOfMonths));

    this.setState({
      date: retDate,
    });
  };

  addMonths = (numOfMonths) => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + numOfMonths));
    this.setState({
      date: retDate,
    });
  };

  subtractWeek = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 6));

    this.setState({
      date: retDate,
    });
  };

  addWeek = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 6));
    this.setState({
      date: retDate,
    });
  };

  subtractQuarter = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - 3));

    this.setState({
      date: retDate,
    });
  };

  addYear = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setYear(newDate.getFullYear() + 1));
    this.setState({
      date: retDate,
    });
  };

  addDay = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    this.setState({
      date: retDate,
    });
  };

  subtractYear = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setYear(newDate.getFullYear() - 1));

    this.setState({
      date: retDate,
    });
  };

  subtractDay = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 1));

    this.setState({
      date: retDate,
    });
  };

  addQuarter = () => {
    var newDate = new Date(this.state.date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 3));
    this.setState({
      date: retDate,
    });
  };

  setDateAndViewForYear = (date) => {
    this.setState({
      loadingData: true,
    });
    this.setState({
      date: date,
      view: "month",
    });
  };

  setViewDay = (e) => {
    this.setState({
      loadingData: true,
    });
    this.setState({
      date: new Date(e.target.value),
      view: "daily",
    });
  };

  setDate = (e) => {
    this.setState({
      loadingData: true,
    });

    if (e.target.value === "next") {
      if (this.state.view === "month") {
        this.addMonths(1);
      } else if (this.state.view === "week") {
        this.addWeek();
      } else if (this.state.view === "quarter") {
        this.addQuarter();
      } else if (this.state.view === "year") {
        this.addYear();
      } else if (this.state.view === "daily") {
        this.addDay();
      }
    } else if (e.target.value === "previous") {
      if (this.state.view === "month") {
        this.subtractMonths(1);
      } else if (this.state.view === "week") {
        this.subtractWeek();
      } else if (this.state.view === "quarter") {
        this.subtractQuarter();
      } else if (this.state.view === "year") {
        this.subtractYear();
      } else if (this.state.view === "daily") {
        this.subtractDay();
      }
    }
  };

  setDateWeek = (e) => {
    this.setState({
      loadingData: true,
    });

    if (e.target.value === "next") {
      this.addWeek();
    } else if (e.target.value === "previous") {
      this.subtractWeek();
    }
  };

  refreshData = (tr, payId, tabIndex) => {
    this.setState({
      loadingData: true,
      loadedStartedData: false,
      docInfo: "",
      hearingsData: [],
      tasksData: [],
      hearingsSheetData: [],
      tasksSheetData: [],
      hearingsTeam2Data: [],
      tasksTeam2Data: [],
      hearingsTeam2SheetData: [],
      tasksTeam2SheetData: [],
      paymentsSheetData: [],
      paymentsData: [],
      transactionsSheetData: [],
      transactionsData: [],
      paymentsArchiveSheetData: [],
      paymentsArchiveData: [],
      tr:
        tr === ""
          ? ""
          : tr === "transaction"
          ? "tr"
          : tr === "transactionNa"
          ? "trNa"
          : tr,
      payId: payId !== undefined ? payId : "",
      tabIndex: tabIndex !== undefined ? tabIndex : 0,
    });
    this.getSheetData();
  };

  refreshDataOnlyHearings = (tr) => {
    this.setState({
      loadingData: true,
      loadedStartedData: false,
      docInfo: "",
      tasksData: [],
      tasksSheetData: [],
      tasksTeam2Data: [],
      tasksTeam2SheetData: [],
      tr:
        tr === ""
          ? ""
          : tr === "transaction"
          ? "tr"
          : tr === "transactionNa"
          ? "trNa"
          : "",
    });
    var load = false;
    setInterval(() => {
      if (!load) {
        try {
          load = this.loadGoogleEnv();
        } catch (e) {
          load = false;
        }
      }
    }, 1000);
    this.getSheetDataOnlyHearings(1);
  };

  generateAnalysis = async (payload, leadId, analysisScript) => {
    var options, url;

    url = analysisScript;
    options = {};
    options.method = "post";
    options.payload = JSON.stringify(payload);

    await fetch(url, {
      method: "post",
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        this.saveAnalysis(data.link, leadId, payload);
      });
  };

  saveAnalysis = async (link, leadId, payload) => {
    var body = {
      id: leadId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          leadId: leadId,
          leadName: data[0].name,
          field: "name",
          value: payload.clientName,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var body5 = {
          leadId: leadId,
          leadName: data[0].name,
          field: "bank",
          value: payload.bankIn,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body5),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var body3 = {
          id: leadId,
          agreement: payload.clientBank,
          creditDate: payload.clientCreditStartDate,
          creditLength: payload.clientCreditLength,
          creditCurrency: payload.creditCurrency,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateLeadAnalysis", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body3),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var body = {
          link: link,
          leadId: leadId,
          leadName: payload.clientName,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addAnalysis", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            this.logSellAction(
              "Wygenerowano analize umowy kredytowej: " + this.state.user.name,
              leadId
            );
            MySwal.fire({
              icon: "success",
              title: "Wygenerowano",
              text: "analizę umowy kredytowej",
            }).then(async (result) => {
              //this.refreshData();
            });
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  handleOptionChange = (e) => {
    this.setState({
      option: e.target.value,
      showAcceptClients: false,
      showDatePopUp: false,
      showTaskPopUp: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showHoliday: false,
      showPayments: false,
      showAddPayments: false,
      showAddClientContact: false,
      showMultiAcceptHearings: false,
      showAddClient: false,
      showClients: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      view: "month",
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  handleOptionChangeLogo = (e) => {
    this.setState({
      option: e.target.alt,
      showAcceptClients: false,
      showDatePopUp: false,
      showTaskPopUp: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showHoliday: false,
      showPayments: false,
      showAddPayments: false,
      showAddClientContact: false,
      showMultiAcceptHearings: false,
      showAddClient: false,
      showClients: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      view: "month",
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  handleOptionChangeClose = (option) => {
    this.setState({
      showDatePopUp: false,
      option: option,
    });
  };

  handleShowCalendar = () => {
    this.setState({
      option: "calendar",
      showAcceptClients: false,
      showAddClientContact: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  setView = (e) => {
    this.setState({
      view: e.target.value,
      loadingData: true,
    });
  };

  handleUserLogin = (user) => {
    this.loadStartedData();
    this.setState({
      user: user,
      loged: 1,
      team: +user.team[0],
      allowedTeam: user.team,
      option: user.role === "consultantTele" ? "" : "calendar",
      showSellSystem: user.role === "consultantTele" ? true : false,
    });
    if (user.role !== "admin") {
      //this.checkForNewPopup(user.name);
    }
  };

  closeDatePopUp = (e) => {
    this.setState({
      showDatePopUp: false,
      popUpDateID: "",
    });
  };

  showAdminPanelF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: true,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeAdminPanelF = (e) => {
    this.setState({
      showAdminPanel: false,
    });
  };

  showFinishLeadsF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: true,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showConfRoomRes = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: true,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeConfRoomRes = (e) => {
    this.setState({
      showConfRoomResS: false,
    });
  };

  showMaterials = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: true,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeMaterials = (e) => {
    this.setState({
      showMaterials: false,
    });
  };

  showMaterialsCons = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: true,
      showSellSystemCalendar: false,
      showPostBook: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showPostBookF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showPostBook: true,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeMaterialsCons = (e) => {
    this.setState({
      showMaterialsCons: false,
    });
  };

  closePostBook = (e) => {
    this.setState({
      showPostBook: false,
    });
  };

  closeFinishLeadsF = (e) => {
    this.setState({
      showFinishLeads: false,
    });
  };

  showSellSystemF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: true,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
    this.closeSellSystemCalendar();
  };

  showSellSystemCalendarF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanel: false,
      showAdminPanelUA: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showSellSystemCalendar: true,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showChceklistReport: false,
      showUndevList: false,
    });
    this.closeSellSystem();
  };

  closeSellSystem = (e) => {
    this.setState({
      showSellSystem: false,
    });
  };

  closeSellSystemCalendar = (e) => {
    this.setState({
      showSellSystemCalendar: false,
    });
  };

  showAdminPanelUAF = (e) => {
    e.preventDefault();
    this.setState({
      showAdminPanelUA: true,
      showAdminPanel: false,
      showAcceptClients: false,
      showAddPayments: false,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showSellSystemCalendar: false,
      showMaterialsCons: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeAdminPanelUAF = (e) => {
    this.setState({
      showAdminPanelUA: false,
    });
  };

  showDatePopUp = (e) => {
    e.preventDefault();
    this.setState({
      showDatePopUp: true,
      popUpDateID: e.currentTarget.value,
    });
  };

  closeAcceptClients = (e) => {
    this.setState({
      showAcceptClients: false,
    });
  };

  showAcceptClients = (e) => {
    e.preventDefault();
    this.setState({
      showAcceptClients: true,
      showAddClientContact: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeSearchPopUp = (e) => {
    this.setState({
      showSearchPopUp: false,
    });
  };

  showAddClientContactPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showAddClientContact: true,
      showSearchPopUp: false,
      showReportPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showSellSystemCalendar: false,
      showMaterialsCons: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showAddClientPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showAddClientContact: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClient: true,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showSearchPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showSearchPopUp: true,
      showReportPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showReportPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showReportPopUp: true,
      showSearchPopUp: false,
      showPayments: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showPaymentsPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showPayments: true,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showAddPaymentsPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showAddPayments: true,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showClients: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showAdminPanelUA: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  closeAddClient = (e) => {
    this.setState({
      showAddClient: false,
    });
  };

  closeAddPayment = (e) => {
    this.setState({
      showAddPayments: false,
    });
  };

  closeAddClientContact = (e) => {
    this.setState({
      showAddClientContact: false,
    });
  };

  showClientsPopUp = (e) => {
    this.setState({
      showAcceptClients: false,
      showClients: true,
      showPayments: false,
      showSearchPopUp: false,
      showReportPopUp: false,
      showMultiAcceptHearings: false,
      showHoliday: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showMultiAcceptHearingsPopUp = (e) => {
    this.setState({
      showMultiAcceptHearings: true,
      showReportPopUp: false,
      showSearchPopUp: false,
      showPayments: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showHolidayPopUp = (e) => {
    this.setState({
      showMultiAcceptHearings: false,
      showReportPopUp: false,
      showSearchPopUp: false,
      showPayments: false,
      showHoliday: true,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: false,
    });
  };

  showChecklistReportPopUp = (e) => {
    this.setState({
      showMultiAcceptHearings: false,
      showReportPopUp: false,
      showSearchPopUp: false,
      showPayments: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: true,
      showUndevList: false,
    });
  };

  showUndev = (e) => {
    this.setState({
      showMultiAcceptHearings: false,
      showReportPopUp: false,
      showSearchPopUp: false,
      showPayments: false,
      showHoliday: false,
      showClients: false,
      showAddPayments: false,
      showAddClientContact: false,
      showAddClient: false,
      showAdminPanel: false,
      showSellSystem: false,
      showFinishLeads: false,
      showConfRoomResS: false,
      showMaterials: false,
      showMaterialsCons: false,
      showSellSystemCalendar: false,
      showChceklistReport: false,
      showUndevList: true,
    });
  };

  closeChecklistReportPopUp = (e) => {
    this.setState({
      showChceklistReport: false,
    });
  };

  closeMultiAcceptHearingsPopUp = (e) => {
    this.setState({
      showMultiAcceptHearings: false,
    });
  };

  closePaymentsPopUp = (e) => {
    this.setState({
      showPayments: false,
    });
  };

  closeClientsPopUp = (e) => {
    this.setState({
      showPClients: false,
    });
  };

  closeReportPopUp = (e) => {
    this.setState({
      showReportPopUp: false,
    });
  };

  closeHolidayPopUp = (e) => {
    this.setState({
      showHoliday: false,
    });
  };

  showTaskPopUp = (e) => {
    e.preventDefault();
    this.setState({
      showTaskPopUp: true,
      popUpTaskID: e.currentTarget.value,
    });
  };

  showSellTaskPopUp = (e) => {
    e.preventDefault();
    this.setState({
      showSellTaskPopUp: true,
      popUpSellTaskID: e.currentTarget.value,
    });
  };

  closeTaskPopUp = (e) => {
    this.setState({
      showTaskPopUp: false,
      popUpTaskID: "",
    });
  };

  closeSellTaskPopUp = (e) => {
    this.setState({
      showSellTaskPopUp: false,
      popUpSellTaskID: "",
    });
  };

  checkPermissions = (perm) => {
    if (+this.state.user[perm] === 1) {
      return true;
    } else {
      return false;
    }
  };

  loadStartedData = (type) => {
    this.getSheetData(type);
    this.setState({
      date:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate()),
    });
  };

  componentDidMount() {
    var type = "";
    if (this.getQueryVariable("clientQuest") !== false) {
      type = "quest";
      this.setState({
        clientQuest: true,
        clientId: +this.getQueryVariable("client"),
      });
    } else if (this.getQueryVariable("clientUpload") !== false) {
      type = "upload";
      this.setState({
        clientUpload: true,
        clientId: +this.getQueryVariable("client"),
      });
    } else if (this.getQueryVariable("clientSKDUpload") !== false) {
      type = "upload";
      this.setState({
        clientSKDUpload: true,
        clientId: +this.getQueryVariable("client"),
      });
    }
  }

  checkForNewPopup = (name) => {
    var nameU = "";
    if (this.state.user.name === undefined) {
      nameU = name;
    } else {
      nameU = this.state.user.name;
    }
    var bool =
      this.state.team === 1
        ? this.state.hearingsData.filter(
            (el) => el.readed === "no" && el.lawyer === nameU
          ).length > 0 ||
          this.state.tasksData.filter(
            (el) => el.readed === "no" && el.responsible === nameU
          ).length > 0
        : this.state.hearingsTeam2Data.filter(
            (el) => el.readed === "no" && el.lawyer === nameU
          ).length > 0 ||
          this.state.tasksTeam2Data.filter(
            (el) => el.readed === "no" && el.responsible === nameU
          ).length > 0;
    if (bool) {
      this.setState({
        checkNewPopup: true,
      });
    }
  };

  closeNewPopUp = async () => {
    this.setState({
      checkNewPopup: false,
    });

    var rowsH = [];
    if (this.state.team === 1) {
      rowsH = await this.state.hearingsSheetData.getRows();
    } else {
      rowsH = await this.state.hearingsTeam2SheetData.getRows();
    }
    var toReadedDataH = rowsH.filter(
      (el) => el.readed === "no" && el.lawyer === this.state.user.name
    );
    if (toReadedDataH !== undefined) {
      toReadedDataH.map(async (el) => {
        el.readed = "yes";
        await el.save();
      });
    }
    var rowsT = [];
    if (this.state.team === 1) {
      rowsT = await this.state.tasksSheetData.getRows();
    } else {
      rowsT = await this.state.tasksTeam2SheetData.getRows();
    }
    var toReadedDataT = rowsT.filter(
      (el) => el.readed === "no" && el.responsible === this.state.user.name
    );

    if (toReadedDataT !== undefined) {
      await toReadedDataT.map((el) => {
        el.readed = "yes";
        el.save();
      });
    }
    this.refreshData();
  };

  setTasksCourtFilter = (e) => {
    this.setState((prevState) => ({
      tasksCourtFilter: !prevState.tasksCourtFilter,
    }));
  };

  setTasksNoCourtFilter = (e) => {
    this.setState((prevState) => ({
      tasksNoCourtFilter: !prevState.tasksNoCourtFilter,
    }));
  };

  setTasksNoClientFilter = (e) => {
    this.setState((prevState) => ({
      tasksNoClientFilter: !prevState.tasksNoClientFilter,
    }));
  };

  setCaseTypeFilter = (e) => {
    this.setState({
      caseTypeFilter: e.target.value,
    });
  };

  setResultFilter = (e) => {
    this.setState({
      resultFilter: e.target.value,
    });
  };

  setClientTypeFilter = (e) => {
    this.setState({
      clientTypeFilter: e.target.value,
    });
  };

  setCaseFormFilter = (e) => {
    this.setState({
      caseFormFilter: e.target.value,
    });
  };

  setCourtFilter = (e) => {
    this.setState({
      courtFilter: e.target.value,
    });
  };

  setTaskTypeFilter = (e) => {
    this.setState({
      taskTypeFilter: e.target.value,
    });
  };

  clearDetailFilters = (e) => {
    this.setState({
      tasksCourtFilter: true,
      tasksNoCourtFilter: true,
      resultFilter: "",
      caseTypeFilter: "",
      caseFormFilter: "",
      courtFilter: "",
      taskTypeFilter: "",
    });
  };

  handleTeamChange = (e) => {
    this.setState({
      team: +e.target.value,
    });

    this.refreshData();
  };

  setViewWeek = (e) => {
    this.setState({
      loadingData: true,
      holidayView: "week",
    });
  };

  setViewMonth = (e) => {
    this.setState({
      loadingData: true,
      holidayView: "month",
    });
  };

  logClientAction = async (value, clientId) => {
    var body = {
      value: value,
      lawyer: this.state.user.name,
      date: new Date(),
      clientId: clientId,
    };

    fetch("https://apidevkppp.ftpeople.pl/logClientAction", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});
  };

  logSellAction = async (value, leadId) => {
    var body = {
      value: value,
      employee: this.state.user.name,
      date: new Date(),
      leadId: leadId,
    };

    fetch("https://apidevkppp.ftpeople.pl/logSellAction", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return false;
  }

  checkEditOption = (option) => {
    return true;
  };

  checkAllowedClient = (id) => {
    var bool = false;
    this.state.user.allowedClients.split(",").map((el) => {
      if (el === id) {
        bool = true;
      }
    });

    return bool;
  };

  render() {
    return (
      <>
        <div onMouseDown={this.refreshIdleTime}>
          {this.state.clientQuest ? (
            <AddQuestionnaireClient
              clientId={this.state.clientId}
              clientsData={this.state.clientsData}
              clientQuestSheet={this.state.clientsQuestSheetData}
              clientQuestData={this.state.clienTQuestData}
              logClientAction={this.logClientAction}
            />
          ) : this.state.clientUpload ? (
            <AddClientSellDocuments
              clientId={this.state.clientId}
              clientsData={this.state.clientsData}
              clientQuestSheet={this.state.clientsQuestSheetData}
              clientQuestData={this.state.clienTQuestData}
              logClientAction={this.logSellAction}
            />
          ) : this.state.clientSKDUpload ? (
            <AddClientSellDocumentsSKD
              clientId={this.state.clientId}
              clientsData={this.state.clientsData}
              clientQuestSheet={this.state.clientsQuestSheetData}
              clientQuestData={this.state.clienTQuestData}
              logClientAction={this.logSellAction}
            />
          ) : this.state.loged === 0 ? (
            <Login
              login={this.state.loged}
              usersData={this.state.usersData}
              handleUserLogin={this.handleUserLogin}
              loadStartedData={this.loadStartedData}
              checkForNewPopup={this.checkForNewPopup}
            />
          ) : (
            <>
              <Header
                user={this.state.user}
                handleOptionChange={this.handleOptionChangeLogo}
                team={this.state.team}
                allowedTeam={this.state.allowedTeam}
                handleTeamChange={this.handleTeamChange}
              />
              <Functionalites
                option={this.state.option}
                handleOptionChange={this.handleOptionChange}
                showSearchPopUp={this.showSearchPopUp}
                showReportPopUp={this.showReportPopUp}
                showPaymentsPopUp={this.showPaymentsPopUp}
                showAddPaymentsPopUp={this.showAddPaymentsPopUp}
                showAddClientContactPopUp={this.showAddClientContactPopUp}
                showAddClientPopUp={this.showAddClientPopUp}
                showClientsPopUp={this.showClientsPopUp}
                showHolidayPopUp={this.showHolidayPopUp}
                user={this.state.user}
                multiAcceptHearings={this.showMultiAcceptHearingsPopUp}
                checkPermissions={this.checkPermissions}
                team={this.state.team}
                showAcceptClients={this.showAcceptClients}
                showAdminPanel={this.showAdminPanelF}
                closeAdminPanel={this.closeAdminPanelF}
                showAdminPanelUA={this.showAdminPanelUAF}
                closeAdminPanelUA={this.closeAdminPanelUAF}
                showSellSystem={this.showSellSystemF}
                showSellSystemCalendar={this.showSellSystemCalendarF}
                showFinishLeads={this.showFinishLeadsF}
                showConfRoomRes={this.showConfRoomRes}
                showMaterials={this.showMaterials}
                showMaterialsCons={this.showMaterialsCons}
                showPostBook={this.showPostBookF}
                showChecklistReportPopUp={this.showChecklistReportPopUp}
                showUndev={this.showUndev}
              />
              <div className="calendarBox">
                {this.state.checkNewPopup ? (
                  <NewPopUp
                    tasksData={this.state.tasksData}
                    hearingsData={this.state.hearingsData}
                    close={this.closeNewPopUp}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksSheetData={this.state.tasksSheetData}
                    lawyersData={this.state.lawyersData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    checkPermissions={this.checkPermissions}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                  />
                ) : (
                  ""
                )}
                {this.state.showAddPayments ? (
                  <>
                    <AddPayment
                      close={this.closeAddPayment}
                      paymentsSheetData={this.state.paymentsSheetData}
                      paymentsData={this.state.paymentsData}
                      refreshData={this.refreshData}
                      transactionsSheetData={this.state.transactionsSheetData}
                      modeAdd={"main"}
                      clients={this.state.clientsData}
                      clientsSygnData={this.state.clientsSygnData}
                      team={this.state.team}
                      user={this.state.user}
                    />
                  </>
                ) : (
                  ""
                )}

                {this.state.showAddClientContact ? (
                  <AddClientContactPopUp
                    close={this.closeAddClientContact}
                    refreshData={this.refreshData}
                    clientsContactData={this.state.clientsContactData}
                    clientsContactSheetData={this.state.clientsContactSheetData}
                    clientsData={[]}
                    logClientAction={this.logClientAction}
                    clients={this.state.clientsData}
                    user={this.state.user}
                    mode={"main"}
                    clientsSygnData={this.state.clientsSygnData}
                    team={this.state.team}
                  />
                ) : (
                  ""
                )}
                {this.state.loadingData || this.state.loadingCalendarData ? (
                  <LoadingPopup />
                ) : this.state.showAdminPanel ? (
                  <AdminPanel
                    close={this.closeAdminPanelF}
                    user={this.state.user}
                  />
                ) : this.state.showSellSystem ? (
                  <SellSystem
                    close={this.closeSellSystem}
                    user={this.state.user}
                    checkPermissions={this.checkPermissions}
                    date={this.state.date}
                    setDate={this.setDate}
                    logLeadAction={this.logSellAction}
                    team={this.state.team}
                    generateAnalysis={this.generateAnalysis}
                    calendar={false}
                    contacts={true}
                  />
                ) : this.state.showSellSystemCalendar ? (
                  <SellSystem
                    close={this.closeSellSystemCalendar}
                    user={this.state.user}
                    checkPermissions={this.checkPermissions}
                    date={this.state.date}
                    setDate={this.setDate}
                    logLeadAction={this.logSellAction}
                    team={this.state.team}
                    generateAnalysis={this.generateAnalysis}
                    calendar={true}
                    contacts={false}
                  />
                ) : this.state.showFinishLeads ? (
                  <AcceptLeads
                    close={this.closeFinishLeadsF}
                    clientsData={this.state.clientsData}
                    clientsSheetData={this.state.clientsSheetData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    clientsLogsData={this.state.clientsLogsData}
                    clientsLogsSheetData={this.state.clientsLogsSheetData}
                    logClientAction={this.logClientAction}
                    tr={this.state.tr}
                    clientId={this.state.payId}
                    clientsContactData={this.state.clientsContactData}
                    clientsContactSheetData={this.state.clientsContactSheetData}
                    paymentsData={this.state.paymentsData}
                    paymentsSheetData={this.state.paymentsSheetData}
                    transactionsData={this.state.transactionsData}
                    transactionsSheetData={this.state.transactionsSheetData}
                    transactionsNaData={this.state.transactionsNaData}
                    transactionsNaSheetData={this.state.transactionsNaSheetData}
                    paymentsArchiveData={this.state.paymentsArchiveData}
                    paymentsArchiveSheetData={
                      this.state.paymentsArchiveSheetData
                    }
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    closeReportPopUp={this.closeReportPopUp}
                    checkPermissions={this.checkPermissions}
                    substitutesData={this.state.substitutesData}
                    taskTypesData={this.state.tasksTypesData}
                    users={this.state.usersData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    clientsSygnData={this.state.clientsSygnData}
                    clientsSygnSheetData={this.state.clientsSygnSheetData}
                    clientsQuestData={this.state.clientsQuestData}
                    clientsQuestSheetData={this.state.clientsQuestSheetData}
                  />
                ) : this.state.showAdminPanelUA ? (
                  <AdminPanelUserAccess
                    close={this.closeAdminPanelUAF}
                    user={this.state.user}
                  />
                ) : this.state.showChceklistReport ? (
                  <ChecklistReport
                    close={this.closeChecklistReportPopUp}
                    user={this.state.user}
                  />
                ) : this.state.showUndevList ? (
                  <UndevDeliveries
                    close={() => {
                      this.setState({ showUndevList: false });
                    }}
                    user={this.state.user}
                  />
                ) : this.state.showDatePopUp ? (
                  <DatePopUp
                    dateID={this.state.popUpDateID}
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    close={this.closeDatePopUp}
                    lawyersData={this.state.lawyersData}
                    substitutesData={this.state.substitutesData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    taskTypesData={this.state.tasksTypesData}
                    history={false}
                    checkPermissions={this.checkPermissions}
                    archDate={this.state.hearingsArchSheetData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    clientsData={this.state.clientsData}
                    filesData={this.state.filesData}
                    tasksTypesData={this.state.tasksTypesData}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showAddClient ? (
                  <AddClient
                    clientsSheetData={this.state.clientsSheetData}
                    lawyersData={this.state.lawyersData}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    close={this.closeAddClient}
                    refreshData={this.refreshData}
                    logClientAction={this.logClientAction}
                    users={this.state.usersData}
                    mode={"add"}
                    editOption={"all"}
                    checkEditOption={this.checkEditOption}
                    userRole={this.state.user.role}
                    paymentsSheetData={this.state.paymentsSheetData}
                    team={this.state.team}
                    userMail={this.state.user.mail}
                    userPhone={this.state.user.phone}
                    user={this.state.user}
                    userD={this.state.user}
                  />
                ) : this.state.showSearchPopUp ? (
                  <SearchPopUp
                    filesData={this.state.filesData}
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    substitutesData={this.state.substitutesData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    history={false}
                    closeSearchPopUp={this.closeSearchPopUp}
                    checkPermissions={this.checkPermissions}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    close={this.handleShowCalendar}
                    clientsData={this.state.clientsData}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showMultiAcceptHearings ? (
                  <AcceptHearings
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    substitutesData={this.state.substitutesData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    history={false}
                    close={this.closeMultiAcceptHearingsPopUp}
                    checkPermissions={this.checkPermissions}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showReportPopUp ? (
                  <ReportPopUp
                    filesData={this.state.filesData}
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    history={false}
                    closeReportPopUp={this.closeReportPopUp}
                    checkPermissions={this.checkPermissions}
                    substitutesData={this.state.substitutesData}
                    taskTypesData={this.state.tasksTypesData}
                    users={this.state.usersData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    close={this.handleShowCalendar}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showAcceptClients ? (
                  <AcceptClients
                    close={this.closeAcceptClients}
                    clientsData={this.state.clientsData}
                    clientsSheetData={this.state.clientsSheetData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    clientsLogsData={this.state.clientsLogsData}
                    clientsLogsSheetData={this.state.clientsLogsSheetData}
                    logClientAction={this.logClientAction}
                    tr={this.state.tr}
                    clientId={this.state.payId}
                    clientsContactData={this.state.clientsContactData}
                    clientsContactSheetData={this.state.clientsContactSheetData}
                    paymentsData={this.state.paymentsData}
                    paymentsSheetData={this.state.paymentsSheetData}
                    transactionsData={this.state.transactionsData}
                    transactionsSheetData={this.state.transactionsSheetData}
                    transactionsNaData={this.state.transactionsNaData}
                    transactionsNaSheetData={this.state.transactionsNaSheetData}
                    paymentsArchiveData={this.state.paymentsArchiveData}
                    paymentsArchiveSheetData={
                      this.state.paymentsArchiveSheetData
                    }
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    closeReportPopUp={this.closeReportPopUp}
                    checkPermissions={this.checkPermissions}
                    substitutesData={this.state.substitutesData}
                    taskTypesData={this.state.tasksTypesData}
                    users={this.state.usersData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    clientsSygnData={this.state.clientsSygnData}
                    clientsSygnSheetData={this.state.clientsSygnSheetData}
                    clientsQuestData={this.state.clientsQuestData}
                    clientsQuestSheetData={this.state.clientsQuestSheetData}
                  />
                ) : this.state.showPayments ? (
                  <Payments
                    close={this.closePaymentsPopUp}
                    paymentsData={this.state.paymentsData}
                    paymentsSheetData={this.state.paymentsSheetData}
                    transactionsData={this.state.transactionsData}
                    transactionsSheetData={this.state.transactionsSheetData}
                    transactionsNaData={this.state.transactionsNaData}
                    transactionsNaSheetData={this.state.transactionsNaSheetData}
                    paymentsArchiveData={this.state.paymentsArchiveData}
                    paymentsArchiveSheetData={
                      this.state.paymentsArchiveSheetData
                    }
                    refreshData={this.refreshData}
                    user={this.state.user}
                    tr={this.state.tr}
                    payId={this.state.payId}
                    clients={this.state.clientsData}
                    team={this.state.team}
                    users={this.state.usersData}
                    logClientAction={this.logClientAction}
                    checkPermissions={this.checkPermissions}
                    lawyersData={this.state.lawyersData}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                  />
                ) : this.state.showClients ? (
                  <Clients
                    filesData={this.state.filesData}
                    clientsData={
                      this.state.user.allowedClients === "all"
                        ? this.state.clientsData
                        : this.state.clientsData.filter((el) =>
                            this.checkAllowedClient(el.identifier)
                          )
                    }
                    clientsSheetData={this.state.clientsSheetData}
                    refreshData={this.refreshData}
                    user={this.state.user}
                    clientsLogsData={this.state.clientsLogsData}
                    clientsLogsSheetData={this.state.clientsLogsSheetData}
                    logClientAction={this.logClientAction}
                    tr={this.state.tr}
                    logLeadAction={this.logSellAction}
                    generateAnalysis={this.generateAnalysis}
                    clientId={this.state.payId}
                    tabIndex={this.state.tabIndex}
                    checkPermissions={this.checkPermissions}
                    clientsContactData={this.state.clientsContactData}
                    clientsContactSheetData={this.state.clientsContactSheetData}
                    paymentsData={this.state.paymentsData}
                    paymentsSheetData={this.state.paymentsSheetData}
                    transactionsData={this.state.transactionsData}
                    transactionsSheetData={this.state.transactionsSheetData}
                    transactionsNaData={this.state.transactionsNaData}
                    transactionsNaSheetData={this.state.transactionsNaSheetData}
                    paymentsArchiveData={this.state.paymentsArchiveData}
                    paymentsArchiveSheetData={
                      this.state.paymentsArchiveSheetData
                    }
                    hearingsData={this.state.hearingsData}
                    hearingsSheetData={this.state.hearingsSheetData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    closeDatePopUp={this.closeDatePopUp}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    closeReportPopUp={this.closeReportPopUp}
                    checkPermissions={this.checkPermissions}
                    substitutesData={this.state.substitutesData}
                    taskTypesData={this.state.tasksTypesData}
                    users={this.state.usersData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    clientsSygnData={this.state.clientsSygnData}
                    clientsSygnSheetData={this.state.clientsSygnSheetData}
                    clientsQuestData={this.state.clientsQuestData}
                    clientsQuestSheetData={this.state.clientsQuestSheetData}
                    close={this.handleShowCalendar}
                  />
                ) : this.state.showTaskPopUp ? (
                  <TaskPopUp
                    taskID={this.state.popUpTaskID}
                    hearingsData={this.state.hearingsData}
                    tasksData={this.state.tasksData}
                    tasksSheetData={this.state.tasksSheetData}
                    closeTaskPopUp={this.closeTaskPopUp}
                    lawyersData={this.state.lawyersData}
                    refreshData={this.refreshData}
                    refreshDataOnlyHearings={this.refreshDataOnlyHearings}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    banksData={this.state.banksData}
                    usersData={this.state.usersData}
                    resultsData={this.state.resultsData}
                    tasksTypesData={this.state.tasksTypesData}
                    history={false}
                    handleOptionChangeClose={this.handleOptionChangeClose}
                    archTasks={this.state.tasksArchSheetData}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    filesData={this.state.filesData}
                    checkPermissions={this.checkPermissions}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showSellTaskPopUp ? (
                  <SellTaskPopUp
                    close={this.closeSellTaskPopUp}
                    taskId={this.state.popUpSellTaskID}
                    user={this.state.user}
                    uData={this.state.user}
                    logLeadAction={this.logSellAction}
                  />
                ) : this.state.showConfRoomResS ? (
                  <ConfRoomRes
                    date={this.state.date}
                    hearingsData={this.state.hearingsData}
                    tasksData={this.state.tasksData}
                    monthData={this.state.monthData}
                    setDate={this.setDate}
                    view={this.state.view}
                    setView={this.setView}
                    setViewDay={this.setViewDay}
                    showDatePopUp={this.showDatePopUp}
                    showTaskPopUp={this.showTaskPopUp}
                    showSellTaskPopUp={this.showSellTaskPopUp}
                    users={this.state.usersData}
                    setForYear={this.setDateAndViewForYear}
                    resultsData={this.state.resultsData}
                    user={this.state.user}
                    courtsData={this.state.courtsData}
                    checkPermissions={this.checkPermissions}
                    userCalendar={this.state.userCalendar}
                    setUserCalendar={this.setUserCalendar}
                    hearingsCalendar={this.state.hearingsCalendar}
                    setHearingsCalendar={this.setHearingsCalendar}
                    tasksCalendar={this.state.tasksCalendar}
                    setTasksCalendar={this.setTasksCalendar}
                    tasksComissioned={this.state.tasksComissioned}
                    setTasksComissioned={this.setTasksComissioned}
                    tasksFinalized={this.state.tasksFinalized}
                    setTasksFinalized={this.setTasksFinalized}
                    tasksSell={this.state.tasksSell}
                    setTasksSell={this.setTasksSell}
                    tasksCourtFilter={this.state.tasksCourtFilter}
                    setTasksCourtFilter={this.setTasksCourtFilter}
                    tasksNoCourtFilter={this.state.tasksNoCourtFilter}
                    setTasksNoCourtFilter={this.setTasksNoCourtFilter}
                    tasksNoClientFilter={this.state.tasksNoClientFilter}
                    setTasksNoClientFilter={this.setTasksNoClientFilter}
                    resultFilter={this.state.resultFilter}
                    setResultFilter={this.setResultFilter}
                    caseTypeFilter={this.state.caseTypeFilter}
                    setCaseTypeFilter={this.setCaseTypeFilter}
                    caseFormFilter={this.state.caseFormFilter}
                    setCaseFormFilter={this.setCaseFormFilter}
                    courtFilter={this.state.courtFilter}
                    setCourtFilter={this.setCourtFilter}
                    clearFilters={this.clearDetailFilters}
                    tasksTypesData={this.state.tasksTypesData}
                    taskTypeFilter={this.state.taskTypeFilter}
                    setTaskTypeFilter={this.setTaskTypeFilter}
                    team={this.state.team}
                    tasksTeam2Data={this.state.tasksTeam2Data}
                    hearingsTeam2Data={this.state.hearingsTeam2Data}
                    hearingsTeam2SheetData={this.state.hearingsTeam2SheetData}
                    tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                    archDateTeam2={this.state.hearingsArchTeam2SheetData}
                    archTasksTeam2={this.state.tasksArchTeam2SheetData}
                    archTasks={this.state.tasksArchSheetData}
                    substitutes={this.state.substitutesData}
                  />
                ) : this.state.showMaterials ? (
                  <Materials
                    close={this.closeMaterials}
                    user={this.state.user}
                  />
                ) : this.state.showMaterialsCons ? (
                  <MaterialsCons close={this.closeMaterialsCons} />
                ) : this.state.showPostBook ? (
                  <PostBook
                    close={this.closePostBook}
                    user={this.state.user}
                    checkPermissions={this.checkPermissions}
                    logClientAction={this.logClientAction}
                  />
                ) : this.state.showHoliday ? (
                  this.checkPermissions("urlopyAdmin") ? (
                    <Holiday
                      team={this.state.team}
                      date={this.state.date}
                      setDate={this.setDate}
                      setDateWeek={this.setDateWeek}
                      monthData={this.state.monthData}
                      users={this.state.usersData}
                      refreshData={this.refreshData}
                      holidaysSheetData={this.state.holidaysSheetData}
                      holidaysData={this.state.holidaysData}
                      holidaysBlockSheetData={this.state.holidaysBlockSheetData}
                      holidaysBlockData={this.state.holidaysBlockData}
                      user={this.state.user}
                      freeDaysData={this.state.freeDaysData}
                      freeDaysSheetData={this.state.freeDaysSheetData}
                      setViewMonth={this.setViewMonth}
                      setViewWeek={this.setViewWeek}
                      holidayView={this.state.holidayView}
                      yearHolidaysData={this.state.yearHolidaysData}
                      close={this.handleShowCalendar}
                      deskResData={this.state.deskResData}
                      desksData={this.state.desksData}
                      tr={this.state.tr}
                    />
                  ) : (
                    <HolidayUser
                      team={this.state.team}
                      date={this.state.date}
                      setDate={this.setDate}
                      monthData={this.state.monthData}
                      users={this.state.usersData}
                      refreshData={this.refreshData}
                      holidaysSheetData={this.state.holidaysSheetData}
                      holidaysData={this.state.holidaysData}
                      holidaysBlockSheetData={this.state.holidaysBlockSheetData}
                      holidaysBlockData={this.state.holidaysBlockData}
                      user={this.state.user}
                      freeDaysData={this.state.freeDaysData}
                      freeDaysSheetData={this.state.freeDaysSheetData}
                      yearHolidaysData={this.state.yearHolidaysData}
                      close={this.handleShowCalendar}
                      deskResData={this.state.deskResData}
                      desksData={this.state.desksData}
                    />
                  )
                ) : (
                  <>
                    <div className="functionalitesBox">
                      {this.state.option === "calendar" ? (
                        <>
                          <Calendar
                            clientsData={this.state.clientsData}
                            refreshData={this.refreshData}
                            logClientAction={this.logClientAction}
                            banksData={this.state.banksData}
                            lawyersData={this.state.lawyersData}
                            usersData={this.state.usersData}
                            date={this.state.date}
                            hearingsData={this.state.hearingsData}
                            tasksData={this.state.tasksData}
                            monthData={this.state.monthData}
                            setDate={this.setDate}
                            view={this.state.view}
                            setView={this.setView}
                            setViewDay={this.setViewDay}
                            showDatePopUp={this.showDatePopUp}
                            showTaskPopUp={this.showTaskPopUp}
                            showSellTaskPopUp={this.showSellTaskPopUp}
                            users={this.state.usersData}
                            setForYear={this.setDateAndViewForYear}
                            resultsData={this.state.resultsData}
                            user={this.state.user}
                            courtsData={this.state.courtsData}
                            checkPermissions={this.checkPermissions}
                            userCalendar={this.state.userCalendar}
                            setUserCalendar={this.setUserCalendar}
                            hearingsCalendar={this.state.hearingsCalendar}
                            setHearingsCalendar={this.setHearingsCalendar}
                            tasksCalendar={this.state.tasksCalendar}
                            setTasksCalendar={this.setTasksCalendar}
                            tasksComissioned={this.state.tasksComissioned}
                            setTasksComissioned={this.setTasksComissioned}
                            tasksFinalized={this.state.tasksFinalized}
                            setTasksFinalized={this.setTasksFinalized}
                            tasksSell={this.state.tasksSell}
                            setTasksSell={this.setTasksSell}
                            tasksCourtFilter={this.state.tasksCourtFilter}
                            setTasksCourtFilter={this.setTasksCourtFilter}
                            tasksNoCourtFilter={this.state.tasksNoCourtFilter}
                            setTasksNoCourtFilter={this.setTasksNoCourtFilter}
                            tasksNoClientFilter={this.state.tasksNoClientFilter}
                            setTasksNoClientFilter={this.setTasksNoClientFilter}
                            resultFilter={this.state.resultFilter}
                            setResultFilter={this.setResultFilter}
                            clientTypeFilter={this.state.clientTypeFilter}
                            setClientTypeFilter={this.setClientTypeFilter}
                            caseTypeFilter={this.state.caseTypeFilter}
                            setCaseTypeFilter={this.setCaseTypeFilter}
                            caseFormFilter={this.state.caseFormFilter}
                            setCaseFormFilter={this.setCaseFormFilter}
                            courtFilter={this.state.courtFilter}
                            setCourtFilter={this.setCourtFilter}
                            clearFilters={this.clearDetailFilters}
                            tasksTypesData={this.state.tasksTypesData}
                            taskTypeFilter={this.state.taskTypeFilter}
                            setTaskTypeFilter={this.setTaskTypeFilter}
                            team={this.state.team}
                            tasksTeam2Data={this.state.tasksTeam2Data}
                            hearingsTeam2Data={this.state.hearingsTeam2Data}
                            hearingsTeam2SheetData={
                              this.state.hearingsTeam2SheetData
                            }
                            tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                            archDateTeam2={
                              this.state.hearingsArchTeam2SheetData
                            }
                            archTasksTeam2={this.state.tasksArchTeam2SheetData}
                            archTasks={this.state.tasksArchSheetData}
                            substitutes={this.state.substitutesData}
                          />
                        </>
                      ) : this.state.option === "add_date" ? (
                        <>
                          <AddDate
                            hearingsSheetData={this.state.hearingsSheetData}
                            hearingsData={this.state.hearingsData}
                            courtsData={this.state.courtsData}
                            banksData={this.state.banksData}
                            usersData={this.state.usersData}
                            refreshData={this.refreshData}
                            user={this.state.user}
                            mode={"add"}
                            handleOptionChangeClose={
                              this.handleOptionChangeClose
                            }
                            checkPermissions={this.checkPermissions}
                            team={this.state.team}
                            tasksTeam2Data={this.state.tasksTeam2Data}
                            hearingsTeam2Data={this.state.hearingsTeam2Data}
                            hearingsTeam2SheetData={
                              this.state.hearingsTeam2SheetData
                            }
                            tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                            archDateTeam2={
                              this.state.hearingsArchTeam2SheetData
                            }
                            archTasksTeam2={this.state.tasksArchTeam2SheetData}
                            archTasks={this.state.tasksArchSheetData}
                            modeAdd={"main"}
                            clients={this.state.clientsData}
                            clientsSygnData={this.state.clientsSygnData}
                            close={this.handleShowCalendar}
                            substitutes={this.state.substitutesData}
                          />
                        </>
                      ) : this.state.option === "add_task" ? (
                        <>
                          <AddTask
                            tasksSheetData={this.state.tasksSheetData}
                            usersData={this.state.usersData}
                            refreshData={this.refreshData}
                            user={this.state.user}
                            tasksTypesData={this.state.tasksTypesData}
                            banksData={this.state.banksData}
                            handleOptionChangeClose={
                              this.handleOptionChangeClose
                            }
                            checkPermissions={this.checkPermissions}
                            courtsData={this.state.courtsData}
                            team={this.state.team}
                            tasksTeam2Data={this.state.tasksTeam2Data}
                            hearingsTeam2Data={this.state.hearingsTeam2Data}
                            hearingsTeam2SheetData={
                              this.state.hearingsTeam2SheetData
                            }
                            tasksTeam2SheetData={this.state.tasksTeam2SheetData}
                            archDateTeam2={
                              this.state.hearingsArchTeam2SheetData
                            }
                            archTasksTeam2={this.state.tasksArchTeam2SheetData}
                            archTasks={this.state.tasksArchSheetData}
                            modeAdd={"main"}
                            clients={this.state.clientsData}
                            clientsSygnData={this.state.clientsSygnData}
                            close={this.handleShowCalendar}
                            logClientAction={this.logClientAction}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
              </div>
              <Footer
                refreshData={this.refreshData}
                user={this.state.user}
                showAdminPanel={this.showAdminPanelF}
                closeAdminPanel={this.closeAdminPanelF}
              />
            </>
          )}
        </div>
      </>
    );
  }
}

export default App;
